//page of constants

export const statusKey = [
  { id: 0, name: "New" },
  { id: 1, name: "Supervisor Approved" },
  { id: 2, name: "PCard Approved" },
  { id: 3, name: "On Hold" },
  { id: 4, name: "Assistance Requested" },
  { id: 5, name: "Assistance Approved" },
  { id: 6, name: "Ordered" },
  { id: 7, name: "Shipped" },
  { id: 8, name: "Out for Delivery" },
  { id: 9, name: "Delivered" },
  { id: 10, name: "Denied" },
  { id: 11, name: "Cancelled" },
  { id: 12, name: "Out of Stock" },
  { id: 13, name: "Order Edited" },
  { id: 15, name: "Order Processing" },
];
export const urgencyKey = [
  { value: 0, label: "High" },
  { value: 1, label: "Standard" },
  { value: 2, label: "Low" },
];
